import { type ObservabilityToolType } from 'types/api/status-checks/status-check'

import type { ExternalIntegrationsParams } from 'queries/external-integrations/types'

export type ExternalIntegrationLoadGeneratorAuthenticationParams = {
  name: string
  type: string
  teamId: string
}

export type ExternalIntegrationStatusCheckAuthenticationParams = {
  name: string
  domain: string | null
  observabilityToolType?: ObservabilityToolType
  teamId: string
}

export const externalIntegrationsQueryKeys = {
  get: (params: ExternalIntegrationsParams) =>
    ['external-integrations', params] as const,
  getLoadGeneratorIntegrations: (params: { teamId: string }) =>
    ['external-integrations/load-generator', params] as const,
  getStatusCheckIntegrations: (params: { teamId: string }) =>
    ['external-integrations/status-check', params] as const
}

export const externalIntegrationsMutationKeys = {
  createAuthentication: (teamId: string) =>
    ['external-integrations/status-check', { teamId }] as const,
  delete: (params?: ExternalIntegrationsParams) =>
    ['external-integrations', params, { method: 'delete' }] as const,
  deleteLoadGeneratorAuthentication: (
    params: ExternalIntegrationLoadGeneratorAuthenticationParams
  ) => ['external-integrations/load-generator', params] as const,
  deleteStatusCheckAuthentication: (
    params: ExternalIntegrationStatusCheckAuthenticationParams
  ) => ['external-integrations/status-check', params] as const,
  updateAuthentication: (teamId: string) =>
    ['external-integrations/status-check', { teamId }] as const
}
